import { display } from "@material-ui/system";
import React, { useEffect, useState } from "react";

const TransactionAlertPreferenceSection = (props: any) => {
    const [selectedRadioOption, setSelectedRadioOption] = useState("not_set");
    const [globalTextValue, setGlobalTextValue] = useState("-1");
    const toolTipMsges: any = {
        PURCHASE: "Purchase includes transactions categorized as spending such as buying a TV or eating out at a restaurant.",
        WITHDRAWAL: "Subscription or Fee includes transactions categorized as charges such as a Netflix subscription or ATM fee.",
        DEPOSIT: "Deposit includes transactions categorized as income such as the direct deposit of your paycheck.",
        TRANSFER:"Transfer includes transactions categorized as transfers where money is sent to another account such as a credit card payment or using a service like PayPal, Venmo or Zelle.",
        UNCATEGORIZED: "Uncategorized includes transactions not categorized or are unknown such as a check, cash withdrawal, or services not classified.",
    };
    useEffect(() => {
        setTimeout(() => {
            if (props.data != null) {
                const globalData = props.data.find((it: any) => it["monitor-name"] === "Global");
                if (globalData != null) {
                    setGlobalTextValue(globalData.value.toString());
                    let radioOption = "";
                    if (globalData.off === "1") {
                        radioOption = "off";
                    } else if (globalData.active === "1") {
                        radioOption = "all";
                    } else {
                        radioOption = "specific";
                    }
                    setSelectedRadioOption(radioOption);
                    props.data
                        .filter((it: any) => it["monitor-name"] !== "Global")
                        .forEach(function (pref: any) {
                            specificCheckBoxEffect("chbox_" + pref.type + "_" + pref.id, pref.active === "1");
                            specificCheckBoxChangeEffect("chbox_" + pref.type + "_" + pref.id, pref.active === "1" && radioOption === "specific");
                        });
                }
            }
        });
    }, [props.data]);

    const handlePurchaseRadioChange = (changeEvent: any) => {
        setSelectedRadioOption(changeEvent.target.value);
        props.radioChanged(changeEvent.target.id, "0");
    };

    const handleSpecificCheckboxChange = (changeEvent: any) => {
        const chkboxId = changeEvent.target.id;
        const isChecked = changeEvent.target.checked;
        props.radioChanged(chkboxId, isChecked ? "1" : "");
    };
    //chbox_purchase_5
    const specificCheckBoxChangeEffect = (checkboxId: string, isChecked: boolean) => {
        let txtBox = document.getElementById(checkboxId + "_value");
        if (txtBox != null) {
            if (isChecked) {
                if (txtBox.attributes.getNamedItem("disabled") != null) {
                    txtBox.attributes.removeNamedItem("disabled");
                }
            } else {
                const attr = document.createAttribute("disabled");
                attr.value = "disabled";
                txtBox.attributes.setNamedItem(attr);
            }
        }
    };
    const specificCheckBoxEffect = (checkboxId: string, isChecked: boolean) => {
        let chkBox: HTMLInputElement = document.getElementById(checkboxId) as HTMLInputElement;
        if (chkBox != null) {
            if (isChecked) {
                chkBox.checked = true;
            } else {
                chkBox.checked = false;
            }
        }
    };
    const textChangeGlobal = (value: string) => {
        const globalData = props.data.find((it: any) => it["monitor-name"] === "Global");
        textChanged(globalData.id, value);
    };
    const textChanged = (id: number, value: string) => {
        props.textChanged(id, value);
    };
    return (
        <React.Fragment>
            <fieldset className="form-row inline">
                {props.data != null ? (
                    <div className="row">
                        <div className="col-xs-12 col-no-gutter">
                            <legend className="legend-label">
                                <label htmlFor={props.typeName.toLowerCase() + "_alert_off"}>
                                    Alert me if {props.typeName === "WITHDRAWAL" ? "SUBSCRIPTION OR FEE" : props.typeName} is over
                                </label>
                                <span className="tooltip-container" role="img" tabIndex={0} style={{padding:"2px"}}>
                                    <em className="las la-info-circle" aria-hidden="true"></em>
                                    <span className={`tooltip-text ${props.typeName==='PURCHASE'&&'flexBox'}`}>
                                       {toolTipMsges[props.typeName]}
                                    </span>
                                </span>
                            </legend>
                        </div>
                        <div className="col-xs-12 col-no-gutter">
                            <div className="row">
                                <div className="col-xs-12 col-no-gutter">
                                    <div className="form-row no-margin">
                                        <div className="form-input">
                                            <label className="form-radio-label" htmlFor={props.typeName.toLowerCase() + "_alert_off"}>
                                                <input
                                                    type="radio"
                                                    id={props.typeName.toLowerCase() + "_alert_off"}
                                                    name={props.typeName.toLowerCase() + "_alert"}
                                                    value="off"
                                                    onChange={(e) => handlePurchaseRadioChange(e)}
                                                    checked={selectedRadioOption === "off"}
                                                />
                                                <span className="form-radio-label-text">Off</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-no-gutter">
                                    <div className="row between-xs">
                                        <div className="col-xs flex-grow-null col-no-gutter">
                                            <div className="form-row no-margin">
                                                <div className="form-input">
                                                    <label className="form-radio-label" htmlFor={props.typeName.toLowerCase() + "_alert_all"}>
                                                        <input
                                                            type="radio"
                                                            id={props.typeName.toLowerCase() + "_alert_all"}
                                                            name={props.typeName.toLowerCase() + "_alert"}
                                                            value="all"
                                                            onChange={(e) => handlePurchaseRadioChange(e)}
                                                            checked={selectedRadioOption === "all"}
                                                        />
                                                        <span className="form-radio-label-text">All Accounts</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xs flex-grow-null col-no-gutter">
                                            <div className="form-row no-margin inline">
                                                <div className="form-label prefix-label">
                                                    <label htmlFor={props.typeName.toLowerCase() + "_alert_value"}>
                                                        <span className="sr-only">Enter {props.typeName.toLowerCase()} alert value for all accounts </span>{" "}
                                                        <abbr title="Dollar">$</abbr>
                                                    </label>
                                                </div>

                                                {globalTextValue !== "-1" ? (
                                                    <div className="form-input">
                                                        <div className="form-input-content">
                                                            <input
                                                                type="text"
                                                                id={props.typeName.toLowerCase() + "_alert_value"}
                                                                name={props.typeName.toLowerCase() + "_alert_value"}
                                                                className="inputbox"
                                                                defaultValue={globalTextValue}
                                                                placeholder="0.00"
                                                                size={10}
                                                                onChange={(e) => textChangeGlobal(e.target.value)}
                                                                ref={props.register({ required: true, pattern: /^[-+]?\d*\.?\d*$/ })}
                                                                disabled={selectedRadioOption !== "all"}
                                                            />
                                                        </div>
                                                        {{ ...props.errors[props.typeName.toLowerCase() + "_alert_value"] }.type === "required" && (
                                                            <span className="form-error form-error-max-width-120">Number required.</span>
                                                        )}
                                                        {{ ...props.errors[props.typeName.toLowerCase() + "_alert_value"] }.type === "pattern" && (
                                                            <span className="form-error form-error-max-width-120">Invalid format. Must be a number.</span>
                                                        )}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-no-gutter">
                                    <div className="form-row no-margin">
                                        <div className="form-input">
                                            <label className="form-radio-label" htmlFor={props.typeName.toLowerCase() + "_alert_specific"}>
                                                <input
                                                    type="radio"
                                                    id={props.typeName.toLowerCase() + "_alert_specific"}
                                                    name={props.typeName.toLowerCase() + "_alert"}
                                                    value="specific"
                                                    onChange={(e) => handlePurchaseRadioChange(e)}
                                                    checked={selectedRadioOption === "specific"}
                                                />
                                                <span className="form-radio-label-text">Specific Accounts</span>
                                            </label>
                                        </div>
                                    </div>

                                    {selectedRadioOption === "specific" && (
                                        <div className="account-list padding-left-xl">
                                            {props.data &&
                                                props.data
                                                    .filter((it: any) => it["monitor-name"] !== "Global")
                                                    .map((pref: any) => (
                                                        <div className="row between-sm" key={"row_" + pref.id}>
                                                            <div className="col-xs-12 col-sm col-no-gutter flex-grow-null">
                                                                <div className="form-row">
                                                                    <div className="form-input">
                                                                        <label
                                                                            className="form-toggle-label"
                                                                            htmlFor={"chbox_" + props.typeName.toLowerCase() + "_" + pref["id"]}
                                                                        >
                                                                            <input
                                                                                type="checkbox"
                                                                                id={"chbox_" + props.typeName.toLowerCase() + "_" + pref["id"]}
                                                                                onChange={(e) => handleSpecificCheckboxChange(e)}
                                                                                disabled={selectedRadioOption !== "specific"}
                                                                            />
                                                                            <span className="form-toggle-label-text">
                                                                                {pref["monitor-nickname"] || pref["monitor-name"]}
                                                                            </span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-xs-12 col-sm col-no-gutter flex-grow-null">
                                                                <div className="form-row inline">
                                                                    <div className="form-label prefix-label">
                                                                        <label htmlFor={"chbox_" + props.typeName.toLowerCase() + "_" + pref["id"] + "_value"}>
                                                                            <span className="sr-only">Enter value in </span> <abbr title="Dollar">$</abbr>
                                                                        </label>
                                                                    </div>
                                                                    <div className="form-input">
                                                                        <div className="form-input-content">
                                                                            <input
                                                                                type="text"
                                                                                id={"chbox_" + props.typeName.toLowerCase() + "_" + pref["id"] + "_value"}
                                                                                name={"chbox_" + props.typeName.toLowerCase() + "_" + pref["id"] + "_value"}
                                                                                className="inputbox"
                                                                                placeholder="0.00"
                                                                                size={10}
                                                                                defaultValue={pref.value}
                                                                                onChange={(e) => textChanged(pref.id, e.target.value)}
                                                                                ref={props.register({ required: true, pattern: /^[-+]?\d*\.?\d*$/ })}
                                                                            />
                                                                        </div>
                                                                        {{ ...props.errors["chbox_" + props.typeName.toLowerCase() + "_" + pref["id"] + "_value"] }
                                                                            .type === "required" && (
                                                                            <span className="form-error form-error-max-width-120">Number required.</span>
                                                                        )}
                                                                        {{ ...props.errors["chbox_" + props.typeName.toLowerCase() + "_" + pref["id"] + "_value"] }
                                                                            .type === "pattern" && (
                                                                            <span className="form-error form-error-max-width-120">
                                                                                Invalid format. Must be a number.
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
            </fieldset>
            <div className="line-divider margin-vertical-l"></div>
        </React.Fragment>
    );
};
export default TransactionAlertPreferenceSection;
